import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { API } from 'constants';
import client from '../../services/template-api';

import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useDefaultSearchParams } from '../../hooks/useDefaultSearchParams';
import { useFetchOptionsForPaginatedSelectWithSWR } from '../../hooks/useFetchOptionsForPaginatedSelectWithSWR';
import { useSwrPageRequestKeysManagingWithContextSaving } from '../../hooks/useSwrPageRequestKeysManagingWithContextSaving';

import { playbookLibrarySortOptions, SORT_TYPES } from '../../constants/sort';

import PageHeader from '../../components/PageHeader';
import PlaybookTemplatesList from './PlaybookTemplatesList/PlaybookTemplatesList';

const PlaybookTemplatesIndexPage = () => {
    const [searchParams] = useSearchParams();
    const ordering = searchParams.get('sort') || SORT_TYPES.created;

    const {
        options: templates,
        totalOptions: total,
        setPage,
        optionsLoading: loading,
        canLoadMoreOptions: canLoadMoreTemplates,
        key,
        nextPageKey,
        isFirstRequestCompleted,
    } = useFetchOptionsForPaginatedSelectWithSWR({
        client,
        route: API.ROUTES.template.playbookTemplate,
        searchParams: { is_live: true, ordering },
        autoFetchNextPage: true,
    });

    const [filteredTemplates, setFilteredTemplates] = useState(templates);

    const [query, setQuery] = useState('');

    useSwrPageRequestKeysManagingWithContextSaving({
        pageAccessor: 'playbookTemplates',
        key,
        nextPageKey,
    });

    useDocumentTitle('Playbook Library');

    useDefaultSearchParams({
        checkPage: false,
        checkSort: true,
        defaultSortType: SORT_TYPES.created,
        availableSortTypes: [SORT_TYPES.created, SORT_TYPES.alphabetical],
    });

    const fetchNextPage = () => setPage((page) => page + 1);

    const isFirstPageLoading = loading && !isFirstRequestCompleted;

    return (
        <div className="page-position flex flex-col bg-white overflow-y-auto hide-scrollbar">
            <PageHeader
                title="Playbook Library"
                description="A collection of templates and examples to inspire your next playbook. "
                backgroundColor="#EEEAF9"
                sortOptions={playbookLibrarySortOptions}
                isClientSideFiltering
                list={templates}
                setFilteredList={setFilteredTemplates}
                useExternalQuery
                query={query}
                setQuery={setQuery}
                usePagination={false}
            />

            <div className="w-full px-5 xs:px-6 lg:px-8 pt-5 lg:pt-6 pb-6 lg:pb-9">
                <PlaybookTemplatesList
                    filteredTemplates={filteredTemplates}
                    total={total}
                    isSearchQuery={!!query}
                    fetchNextPage={fetchNextPage}
                    canLoadMoreTemplates={canLoadMoreTemplates}
                    isFirstPageLoading={isFirstPageLoading}
                    isLoading={loading}
                />
            </div>
        </div>
    );
};

export default PlaybookTemplatesIndexPage;
